import z from 'zod';
import { AuditSchema } from '../settings/audit-schema';
import { SubscriptionSchema } from '../finance/subscription-schema';

export const OwnerBaseSchema = z.object({
  email: z.string().email(),
  account_type: z.enum(['business', 'admin']).default('business'),
  subscription: SubscriptionSchema.default({
    plan: 'SOLO',
    isFounder: false,
    expiresAt: null,
    updatedAt: null,
  }),
  audit: AuditSchema,
});

export type OwnerBase = z.infer<typeof OwnerBaseSchema>;
